/*
 * Recently Viewed Products
 * ------------------------------------------------------------
 * Records the current product (PDP) into localStorage, then renders the
 * visitor's recently viewed products into the Recently Viewed section by
 * fetching each card via /products/{handle}?view=card (templates/product.card.liquid)
 * and injecting it into the empty Swiper wrapper rendered by
 * sections/recently-viewed.liquid.
 */
(function () {
  var STORAGE_KEY = 'recently_viewed';
  var MAX_STORED = 10;
  var MIN_TO_SHOW = 1; // hide the section unless at least this many *other* products exist

  function onReady(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function readList() {
    var list;
    try {
      list = JSON.parse(localStorage.getItem(STORAGE_KEY));
    } catch (e) {
      list = null;
    }
    return Array.isArray(list) ? list : [];
  }

  function writeList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable / full — fail silently */
    }
  }

  function num(el, attr, fallback) {
    var v = parseInt(el.getAttribute(attr), 10);
    return isNaN(v) ? fallback : v;
  }

  onReady(function () {
    var section = document.querySelector('.recently-viewed-product[data-current-handle]');
    if (!section) {
      return; // not a PDP, or section disabled
    }

    var currentHandle = section.getAttribute('data-current-handle');
    var list = readList();

    // Record the current product: move-to-front, dedupe, cap.
    if (currentHandle) {
      list = list.filter(function (h) {
        return h !== currentHandle;
      });
      list.unshift(currentHandle);
      list = list.slice(0, MAX_STORED);
      writeList(list);
    }

    // Build the display list (exclude the product currently being viewed).
    var limit = num(section, 'data-limit', MAX_STORED);
    var toShow = list
      .filter(function (h) {
        return h !== currentHandle;
      })
      .slice(0, limit);

    if (toShow.length < MIN_TO_SHOW) {
      return; // keep the section hidden
    }

    var wrapper = section.querySelector('.swiper-wrapper');
    if (!wrapper) {
      return;
    }

    var requests = toShow.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '?view=card')
        .then(function (res) {
          return res.ok ? res.text() : null;
        })
        .catch(function () {
          return null; // skip deleted / unavailable products
        });
    });

    Promise.all(requests).then(function (results) {
      var html = '';
      results.forEach(function (markup) {
        if (markup && markup.trim()) {
          html += '<div class="swiper-slide">' + markup + '</div>';
        }
      });

      if (!html) {
        return; // every fetch failed — stay hidden
      }

      wrapper.innerHTML = html;
      section.style.display = '';
      initSwiper(section);

      if (window.AOS && typeof AOS.refresh === 'function') {
        AOS.refresh();
      }
    });
  });

  function initSwiper(section) {
    if (typeof Swiper === 'undefined') {
      return;
    }

    var slider = section.querySelector('.swiper');
    if (!slider || !slider.id) {
      return;
    }

    var rows = num(section, 'data-rows', 1);
    var autoplayOn = section.getAttribute('data-autoplay') === 'true';
    var autoplayTimeout = num(section, 'data-autoplay-timeout', 5000);
    var rtl = section.getAttribute('data-rtl') === 'true';

    function grid() {
      return { rows: rows, fill: 'row' };
    }

    var config = {
      slidesPerView: num(section, 'data-pv-desktop', 4),
      grid: grid(),
      spaceBetween: 30,
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      breakpoints: {
        0: { slidesPerView: num(section, 'data-pv-320', 1), grid: grid(), spaceBetween: 12 },
        320: { slidesPerView: num(section, 'data-pv-320', 1), grid: grid(), spaceBetween: 12 },
        360: { slidesPerView: num(section, 'data-pv-360', 2), grid: grid(), spaceBetween: 12 },
        540: { slidesPerView: num(section, 'data-pv-540', 2), grid: grid(), spaceBetween: 12 },
        640: { slidesPerView: num(section, 'data-pv-640', 2), grid: grid(), spaceBetween: 12 },
        768: { slidesPerView: num(section, 'data-pv-768', 2), grid: grid(), spaceBetween: 30 },
        1024: { slidesPerView: num(section, 'data-pv-1024', 3), grid: grid(), spaceBetween: 30 },
        1199: { slidesPerView: num(section, 'data-pv-1199', 3), grid: grid(), spaceBetween: 30 },
        1399: { slidesPerView: num(section, 'data-pv-1399', 3), grid: grid(), spaceBetween: 30 },
        1499: { slidesPerView: num(section, 'data-pv-desktop', 4), grid: grid(), spaceBetween: 30 }
      }
    };

    if (rtl) {
      config.rtl = true;
    }
    if (autoplayOn) {
      config.autoplay = { delay: autoplayTimeout };
    }

    new Swiper('#' + slider.id, config);
  }
})();
